import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

interface TitleStyleProps {
  lgBigSize?: number;
}

interface Title extends TitleStyleProps {
  text: string;
  className?: string;
}

interface FeatureTextContentProps {
  className?: string;
  icon?: ReactNode;
  title: Title;
  text?: { text: string; className?: string };
}
const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    marginBottom: theme.spacing(8),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(10),
    },
  },
  title: {
    marginBottom: theme.spacing(3),
    whiteSpace: 'pre-line',
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: ({ lgBigSize }: TitleStyleProps) => lgBigSize && lgBigSize,
    },
  },
}));

const FeatureTextContent: FC<FeatureTextContentProps> = ({ className, children, icon, title, text }) => {
  const classes = useStyles({ lgBigSize: title.lgBigSize });

  return (
    <Box className={className}>
      {icon && <div className={classes.icon}>{icon}</div>}
      <Typography variant="h3" className={clsx(classes.title, title.className)}>
        {title.text}
      </Typography>
      {text && (
        <Typography variant="body2" className={text.className}>
          {text.text}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default FeatureTextContent;
